import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useManageGetRequest } from "../../../../../../hooks/useManageGetRequest/useManageGetRequest";
import { isNullOrUndefinded } from "../../../../../../helper/utils";
import { cuadroRequerimientosGetDataToEditAsignacionAPI } from "../../../../../../consumers/backendApisUrls";

export default function CuadroRequerimientosAsignacionTooltip({ idAsignacion, position, onClose }) {
    const [manageGetRequest] = useManageGetRequest();
    const [data, setData] = useState({});

    useEffect(() => {
        if (!isNullOrUndefinded(idAsignacion)){
            setData({});
            getDataByIdAsignacion()
        }

    }, [idAsignacion])

    const getDataByIdAsignacion = async () => {
        await manageGetRequest(cuadroRequerimientosGetDataToEditAsignacionAPI(idAsignacion), callbackSuccessGetData, false);
    }

    const callbackSuccessGetData = (response) => {
        setData(response.data)
    }

    return (
        <TooltipContainer
            style={{
                top: position?.y ?? 0,
                left: position?.x ?? 0
            }}
        >
            <CloseButton onClick={onClose} aria-label="Cerrar">
                &times;
            </CloseButton>

            <Header>
                <Avatar
                    src={data.UrlFotoPerfilProfesor
                        ? data.UrlFotoPerfilProfesor.replace("=s96-c", "=s200-c")
                        : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
                    }
                    referrerPolicy="no-referrer"
                    loading="lazy"
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png";
                    }}
                />
                <HeaderText>
                    <Nombre title={data.EmpleadoProfesor}>{data.EmpleadoProfesor || "Vacante"}</Nombre>
                    <Cargo>{data.CargoProfesor}</Cargo>
                </HeaderText>
            </Header>

            <Body>
                <InfoRow>
                    <Label>Especialidad:</Label>
                    <Value>{data.EspecialidadProfesor}</Value>
                </InfoRow>
                <InfoRow>
                    <Label>Total Bloques:</Label>
                    <Value>{data.NroTotalBloquesForAsignacion}</Value>
                </InfoRow>
            </Body>

            <Footer>
                <div>Modificado por: <strong>{data.UltimoUsuarioModifica}</strong></div>
                <div>Fecha: <span>{data.UltimaFechaModifica}</span></div>
            </Footer>
        </TooltipContainer>
    );
}


const TooltipContainer = styled.div`
    position: fixed;
    z-index: 9999;
    background: #ffffff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05);
    border: 1px solid #d1d5db;
    width: 320px;
    font-family: 'Inter', -apple-system, sans-serif;
    animation: fadeIn 0.15s ease-out;

    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(4px); }
        to { opacity: 1; transform: translateY(0); }
    }
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    min-height: 48px;
`;

const Avatar = styled.img`
    width: 48px;
    height: 48px;
    border-radius: 10px;
    object-fit: cover;
    flex-shrink: 0;
    border: 1px solid #e5e7eb;
`;

const HeaderText = styled.div`
    display: flex;
    flex-direction: column;
    padding-right: 28px;
    overflow: hidden;
`;

const Nombre = styled.div`
    font-weight: 700;
    font-size: 15px;
    color: #1e293b;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const Cargo = styled.div`
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-top: 2px;
`;

const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const InfoRow = styled.div`
    display: grid;
    grid-template-columns: 100px 1fr;
    align-items: start;
    gap: 8px;
`;

const Label = styled.span`
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
`;

const Value = styled.span`
    font-size: 13px;
    font-weight: 500;
    color: #334155;
    line-height: 1.4;
`;

const Footer = styled.div`
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid #94a3b8;
    font-size: 11px;
    color: #94a3b8;
    display: flex;
    flex-direction: column;
    gap: 4px;

    strong {
        color: #475569;
        font-weight: 600;
    }
`;

const CloseButton = styled.button`
    position: absolute;
    top: 12px;
    right: 12px;
    background: #f1f5f9;
    border: none;
    width: 26px;
    height: 26px;
    border-radius: 8px;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 20px;
    z-index: 10;

    &:hover {
        background: #e2e8f0;
        color: #0f172a;
    }

    &:focus {
        outline: none;
    }
`;